import { Button, Result } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface RestrictedAccessProps {
  message?: string;
  subTitle?: string;
  backHome?: boolean;
  homePath?: string;
  onBackHomeClick: (() => void) | undefined;
}

const RestrictedAccess: React.FC<RestrictedAccessProps> = ({
  message,
  subTitle,
  backHome = true,
  homePath = '/',
  onBackHomeClick,
}) => {
  const navigate = useNavigate();

  const handleBackHomeClick = () => {
    if (onBackHomeClick) {
      onBackHomeClick();
    }
    navigate(homePath);
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle={subTitle || message || 'Sorry, you are not authorized to access this page.'}
      extra={
        backHome ? (
          <Link to={homePath}>
            <Button type="primary" onClick={handleBackHomeClick}>
              Back Home
            </Button>
          </Link>
        ) : null
      }
    />
  );
};

export default RestrictedAccess;
